import './art-utils';
import index from './index_m/index_m'; // 首页
const art = {
  render() {
    // 保证head只渲染一次
    if (!window.hasRenderHead) {
      window.hasRenderHead = true;
    }
    index.render();
  },
};

export default art;